import { render, staticRenderFns } from "./CollegeRealName.vue?vue&type=template&id=554c6f50&scoped=true&"
import script from "./CollegeRealName.vue?vue&type=script&lang=js&"
export * from "./CollegeRealName.vue?vue&type=script&lang=js&"
import style0 from "./CollegeRealName.vue?vue&type=style&index=0&id=554c6f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c6f50",
  null
  
)

export default component.exports